<ul class="flex flex-col gap-3">
    <li class="text-base text-muted flex items-center justify-between w-full" *ngFor="let data of dataSource">
      <mat-checkbox class="example-margin" 
     [checked]="itemsPush.includes(data.Value)"
      (change)="changeSelected(data.Value, $event)"
      value="{{data.value}}" color="primary">
        <span class="text-sm text-black font-semibold"> {{data.Title}}</span>
      </mat-checkbox>
     
    </li>
   
  </ul>
